import { render } from "./NavigationPhone.vue?vue&type=template&id=21593c8a"
import script from "./NavigationPhone.vue?vue&type=script&lang=js"
export * from "./NavigationPhone.vue?vue&type=script&lang=js"

import "./NavigationPhone.vue?vue&type=style&index=0&id=21593c8a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__